import { RIASEC_ITEMS, RIASEC_DIMS, RIASEC_SCALES } from "./questionBank.js";
import { computeRIASEC } from "./scoring.js";
export { RIASEC_DIMS };

const CareerInterestProfile = {
  id:"riasec", name:"Career Interest Profile", shortName:"Career Interests",
  icon:"🧭", color:"#7c3aed", bg:"#f5f3ff",
  description:"48-item career interest assessment built on Holland's (1959, 1997) RIASEC model — Realistic, Investigative, Artistic, Social, Enterprising, Conventional. Measures which kinds of work activities a person naturally finds engaging, independent of their current skill level, producing a 3-letter Holland Code and career theme suggestions. This is an original instrument built on public-domain vocational psychology theory — it is not affiliated with, and does not reproduce content from, any commercially licensed interest inventory.",
  desc:"48 items · 12 minutes · Interest profile, not an ability or personality measure",
  publisher:"AXIS360 Enterprise", version:"1.0",
  itemCount:48, items:48, timeLimit:12, time:"12 min", timeEstimate:"12 minutes",
  format:"likert_0_4", scaleType:"likert-5", isScreener:false, pricingTier:"standard", creditCost:12,
  pagesOf:48, totalPages:1, scaleMin:0, scaleMax:4,
  scale:{ min:0, max:4, labels:["Strongly Dislike","Dislike","Neutral","Enjoy","Strongly Enjoy"] },
  scaleLabels:["Strongly Dislike","Dislike","Neutral","Enjoy","Strongly Enjoy"],
  predicts:["Which broad categories of work activity a person finds intrinsically engaging","Career/role themes likely to sustain long-term motivation","Areas of likely mismatch between current role and natural interest pattern"],
  questions: RIASEC_ITEMS,
  dims: RIASEC_DIMS,
  scales: RIASEC_SCALES,
  score(answers){ return computeRIASEC(answers); },
  nineboxAxes:{ x:{label:"Career Interest",scaleIds:["riasec"]}, y:{label:"Career Interest",scaleIds:["riasec"]} },
};
export default CareerInterestProfile;
